module.exports = __webpack_public_path__ + "e27e018b5ebf7b32d0822ae0694b4073.MP3";